import { useFeatureIsOn } from '@growthbook/growthbook-react';
import classNames from 'classnames';
import FEATURES from '../../constants/featureToggling';
import MainNavigation from './MainNavigation/MainNavigation';
import NavigationBlockCategories from './NavigationBlockCategories/NavigationBlockCategories';
import NavigationBlockProviders from './NavigationBlockProviders/NavigationBlockProviders';
import NavigationBlockThemes from './NavigationBlockThemes/NavigationBlockThemes';

import styles from './NavigationBlock.module.css';

const Navigation = ({ className }) => {
  const isStickySideMenu = useFeatureIsOn(FEATURES.ENABLED_STICKY_SIDE_MENU);

  return (
    <nav
      role="navigation"
      className={classNames(className, {
        [styles.sticky]: isStickySideMenu,
      })}
    >
      <MainNavigation />

      <NavigationBlockCategories />
      <NavigationBlockThemes />
      <NavigationBlockProviders />
    </nav>
  );
};

export default Navigation;
